import React, { Component, createRef } from 'react';
import Parser from 'html-react-parser';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ChevronLeftIcon, ChevronRightIcon, ArrowIcon } from './SVGIcons';

// Импорт стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';

class First extends Component {
  static defaultProps = {
    otstup: 1
  }

  state = {
    isBeginning: true,
    isEnd: false,
    lightboxOpen: false,
    currentImageIndex: 0
  }

  constructor(props) {
    super(props);
    this.swiperRef = createRef();
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    });
  }

  // Открыть lightbox с выбранным изображением
  openLightbox = (index) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: index
    });
    // Блокируем прокрутку страницы
    document.body.style.overflow = 'hidden';
  }

  // Закрыть lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    });
    // Возвращаем прокрутку страницы
    document.body.style.overflow = 'auto';
  }

  // Переключение на следующее изображение
  nextImage = () => {
    const { currentImageIndex } = this.state;
    const items = this.generateItems();
    
    if (currentImageIndex < items.length - 1) {
      this.setState({
        currentImageIndex: currentImageIndex + 1
      });
    }
  }

  // Переключение на предыдущее изображение
  prevImage = () => {
    const { currentImageIndex } = this.state;
    
    if (currentImageIndex > 0) {
      this.setState({
        currentImageIndex: currentImageIndex - 1
      });
    }
  }

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return;
    
    if (e.key === 'Escape') {
      this.closeLightbox();
    } else if (e.key === 'ArrowRight') {
      this.nextImage();
    } else if (e.key === 'ArrowLeft') {
      this.prevImage();
    }
  }

  // Генерация 10 документов
  generateItems = () => {
    const data = this.props?.data || {}
    return data?.documenti?.list || [];
  }

  componentDidMount() {
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  render() {
    const { isBeginning, isEnd, lightboxOpen, currentImageIndex } = this.state;
    const items = this.generateItems();
    const currentImage = items[currentImageIndex];

    const { otstup } = this.props

    const data = this.props?.data || {}
    const documenti = data?.documenti || {}

    return (
      <>
        <div className={`${otstup == 1 ? `mt-[40px]` : `mt-[80px] xl:mt-[100px]`} w-full`}>
          <div className='container'>
            <div className='text-title text-ptblack uppercase tracking-tight leading-none'>
              {Parser(documenti?.h1 || data?.pagetitle)}
            </div>
            <div className='w-full flex justify-between items-center mt-[12px]'>

              <div className='text-base text-ptgray max-w-[672px] leading-none'>
                {Parser(documenti?.introtext || '')}
              </div>

              {/* Навигация слайдера */}
              <div className='hidden xl:flex items-center justify-end gap-[10px]'>
                <div
                  className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#001553] hover:text-white'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <ChevronLeftIcon />
                </div>
                <div
                  className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#001553] hover:text-white'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <ChevronRightIcon />
                </div>
              </div>

            </div>

            {/* Слайдер Swiper */}
            <div className='mt-[40px] hidden xl:block'>
              <Swiper
                onSwiper={(swiper) => {
                  this.swiperRef.current = swiper;
                  this.handleSlideChange(swiper);
                }}
                onSlideChange={this.handleSlideChange}
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={4}
                className='documentation-slider'
              >
                {items.map((item, index) => (
                  <SwiperSlide key={item.id}>
                    <div className='py-[20px]'>
                      <div 
                        className='rounded-[14px] xl:min-h-[394px] bg-[#F6F7F8] p-[10px] cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-lg h-full flex flex-col'
                        onClick={() => this.openLightbox(index)}
                      >
                        <img 
                          src={item.image} 
                          alt={item.name} 
                          className='w-full h-auto rounded-[15px] object-cover'
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* Мобильная версия - горизонтальный скролл */}
            <div className='mt-[20px] flex xl:hidden gap-[10px] w-full overflow-x-auto overflow-y-hidden pb-[10px]'>
              {items.map((item, index) => (
                <div 
                  key={item.id}
                  className='rounded-[14px] bg-[#F6F7F8] p-[10px] cursor-pointer flex flex-col w-[230px] flex-none transition-all duration-300 hover:-translate-y-2 hover:shadow-lg'
                  onClick={() => this.openLightbox(index)}
                >
                  <img 
                    src={item.image} 
                    alt={item.name} 
                    className='w-full h-auto rounded-[15px] object-cover'
                    loading="lazy"
                  />
                </div>
              ))}
            </div>

            {otstup == 1 &&
              <div className='mt-[80px] xl:mt-[100px] flex flex-col xl:flex-row justify-between items-center gap-[20px]'>
                <div className='flex-auto'>
                  <div className='text-title text-ptblack uppercase tracking-tight leading-none'>
                    {Parser(documenti?.h2 || '')}
                  </div>
                  <div className='text-base text-ptgray max-w-[672px] leading-none mt-[12px]'>
                    {Parser(documenti?.text2 || '')}
                  </div>
                  <div className='flex justify-start'>
                    <a href={data?.links?.about} className='w-full xl:w-auto mt-[27px] cursor-pointer bg-[#F6F7F8] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553] transition-all duration-300 hover:bg-[#001553] hover:text-white group'>
                      <div className='text-base transition-colors duration-300 group-hover:text-white'>О компании</div>
                      <ArrowIcon className="transition-colors duration-300 group-hover:stroke-white" stroke="currentColor" />
                    </a>
                  </div>
                </div>
                <img src={documenti?.image1} alt='' width={172} height={206} className='rounded-[12px] object-cover w-full xl:w-auto h-[200px] xl:h-auto flex-none' />
                <img src={documenti?.image2} alt='' width={482} height={206} className='rounded-[12px] object-cover w-full xl:w-auto h-[160px] xl:h-auto flex-none' />
              </div>
            }
          </div>
        </div>

        {/* Lightbox для увеличения документа */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {currentImageIndex > 0 && (
              <button 
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
                onClick={(e) => {
                  e.stopPropagation();
                  this.prevImage();
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={currentImage?.image} 
                alt={currentImage?.name || 'Увеличенный документ'}
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Название документа и счетчик */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm flex gap-4 whitespace-nowrap'>
                <span>{currentImage?.name}</span>
                <span className='text-gray-300'>{currentImageIndex + 1} / {items.length}</span>
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {currentImageIndex < items.length - 1 && (
              <button 
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
                onClick={(e) => {
                  e.stopPropagation();
                  this.nextImage();
                }}
              >
                ›
              </button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default First;